import GHSphereGeometry from './GHSphereGeometry';
import GHMesh from './GHMesh';

export default class GHHandle extends GHMesh {
  constructor (center, component, unit) {
    let geometry = GHHandle.createGeometry();
    let material = new THREE.MeshStandardMaterial({
      side: THREE.DoubleSide,
      metalness: 0.1,
      roughness: 0.85,
      color: new THREE.Color('rgb(255,61,61)')
    });

    super(null, geometry, material);

    // this.pos = center.clone()
    this.component = component;
    this.unit = unit;
    this.position.set(center.x * unit, center.y * unit, center.z * unit);
    // this.ratio = 0.5
  }

  static createGeometry () {
    let geometry = new GHSphereGeometry(50, 32, 32);
    geometry.verticesNeedUpdate = true;
    geometry.elementsNeedUpdate = true;
    geometry.normalsNeedUpdate = true;
    geometry.setSelectable(true);
    geometry.setVisible(true);
    return geometry;
  }

  update (pos = null) {
    if (pos !== null) {
      this.position.set(pos.x * this.unit, pos.y * this.unit, pos.z * this.unit);
    } else {
      this.updateRatio(this.component.handlePosRatio);
    }
  }

  updateRatio (ratio = null, fromZero = false) {
    // this.ratio = ratio
    this.component.updateHandlePosRatio(ratio, fromZero);
    this.update(this.component.handlePos);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/geometry/GHHandle.js